module.exports = __webpack_public_path__ + "img/p97.67dfd79e.jpg";